import PostApi from "../../../plugins/AdminTemplate/includes/logic/Api/PostApi";

export default class FileApi {
  constructor(
    private readonly url?: string,
  ) {}

  public uploadFile(formData: FormData, signal?: AbortSignal, setProgress?: (val: number) => void) {
    const FIFTEEN_MINUTES = 300000 * 3

    return PostApi.sendRequest<{file_descriptor: string}, FormData>('tg', 'uploadfile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      signal,
      timeout: FIFTEEN_MINUTES,
      ...setProgress ? {
        onUploadProgress: ({ loaded, total }) => {
          if (total) {
            setProgress(Math.round((loaded / total) * 100))
          }
        }
      } : {}
    })
  }

  public getFilePreviewUrl(file_key: string, target: string): string {
    return `${ PostApi.getRequestUrl('tg', 'getfilepreview') }?file_descriptor=${ file_key }&target=${ target }`
  }

  public downloadFile(descriptor: string, target: string): void {
    window.open(`${ PostApi.getRequestUrl('tg', 'downloadfile') }?file_descriptor=${ descriptor }&target=${ target }`)
  }
}
